// ClockProvider.tsx
import React, { createContext, useContext, useEffect, useState } from 'react';

const ClockContext = createContext<Date>(new Date());

export const useClock = () => useContext(ClockContext);

export const ClockProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [now, setNow] = useState(new Date());

    useEffect(() => {
        let animationFrame: number;
        let timeout: NodeJS.Timeout;

        const update = () => {
            setNow(new Date());

            // zpoždění do další celé sekundy
            const delay = 1000 - (Date.now() % 1000);

            timeout = setTimeout(() => {
                animationFrame = requestAnimationFrame(update);
            }, delay);
        };

        update();

        return () => {
            clearTimeout(timeout);
            cancelAnimationFrame(animationFrame);
        };
    }, []);

    return <ClockContext.Provider value={now}>{children}</ClockContext.Provider>;
};